export const StoragePath = {
    THEME_STORAGE: "prefferedTheme",
    TOKEN_STORAGE: "authToken"
} 